<template>
  <div class="box">
    <video
      id="video1"
      controls="true"
      controlslist="nodownload"
      autoplay="autoplay"
      class="myVido"
      v-if="video_url"
    >
      <source
        :src="video_url"
        type="video/mp4"
      />
    </video>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: 1,
      video_url: "",
      video_img: [],
    };
  },
  mounted() {
    this.getculture()
  },
  methods: {
    async getculture() {
      const [err, res] = await this.$http.get("culture");
      if (err) {
        return;
      }
      this.culture = res;
      let videoList = [];
      window.oncontextmenu = function (e) {
        //取消默认的浏览器自带右键 很重要！！
        e.preventDefault();
      };
      let locationHref = window.location.href
        .slice(window.location.href.indexOf("?") + 1)
        .split("&");
      let locationHrefObject = {};
      locationHref.forEach(function (val) {
        let parameter = val.slice(0, val.indexOf("=")); //属性
        let data = val.slice(val.indexOf("=") + 1); //值
        locationHrefObject[parameter] = data;
      });
      this.id = locationHrefObject["id"];
      res.list.forEach((item) => {
        if (item.resourceType == "video" && item.id ==  this.id) {
          this.video_url = item.extends
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  height: 100vh;
  width: 100%;
  background: #000;
}
.myVido {
  width: 100%;
  height: 95vh;
}
</style>
